import {atom } from "recoil"

export const JoinTermsValue = atom<number[]>({
    key: 'JoinTermsValue',
    default: [0,0,0,0,0,0,0,0,0]
})
export const MvnoCheckValue = atom<boolean>({
    key: 'MvnoCheckValue',
    default: false
})